import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgYesGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M39.9 9.38a.75.75 0 0 0-1.02-.28c-12.61 7.21-16.86 21.73-18.14 28.04-1.45-3.46-4.81-8.9-11.83-10.37-.4-.08-.8.18-.89.58-.08.41.18.8.58.89 9.5 1.98 11.63 12.06 11.65 12.16.07.35.38.6.73.6h.04c.37-.02.67-.3.71-.67.02-.21 2.27-20.99 17.9-29.92.35-.22.48-.67.27-1.03Z",
    fill: "currentColor"
  }));
}

export { SvgYesGlyphSecondary as default };
